import { render } from "./NoteCard.vue?vue&type=template&id=76fd7b18&scoped=true"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"

import "./NoteCard.vue?vue&type=style&index=0&id=76fd7b18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fd7b18"]])

export default __exports__